import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store'
import { buildTitle } from '../utils/seoTitle'

const AboutFeaturesPage = () => import("../views/information/AboutFeaturesPage")
const PrivacyPage = () => import("../views/information/PrivacyPage")
const TermsPage = () => import("../views/information/TermsPage")
const WhoWeArePage = () => import("../views/information/WhoWeArePage")

const CreateAircraft = () => import("../views/admin/aircraft/CreateAircraft")
const ModifyAircraft = () => import("../views/admin/aircraft/ModifyAircraft")

const AdminCompanies = () => import("../views/admin/company/AdminCompanies")
const CreateCompany = () => import("../views/admin/company/CreateCompany")
const ModifyCompany = () => import("../views/admin/company/ModifyCompany")

const ChatPage = () => import("../views/chat/ChatPage")
const InsightsPage = () => import("../views/insights/InsightsPage")

const NewslettersPage = () => import("../views/newsletter/NewslettersPage")
const NewsArticlePage = () => import("../views/newsletter/NewsArticlePage")
const AdminPR = () => import("../views/admin/newsletter/AdminPR")
const CreateNewsletter = () => import("../views/admin/newsletter/CreateNewsletter")
const ModifyNewsletter = () => import("../views/admin/newsletter/ModifyNewsletter")
const AdminEvents = () => import("../views/admin/event/AdminEvents")
const UserCreateNewsletter = () => import("../views/user/newsletter/UserCreateNewsletter")
const UserNewslettersList = () => import("../views/user/newsletter/UserNewslettersList")
const UserModifyNewsletter = () => import("../views/user/newsletter/UserModifyNewsletter")

const HubPage = () => import("../views/hub/HubPage")
const AdsList = () => import("../views/ad/AdsList")
const AdPage = () => import("../views/ad/AdPage")
const AdminAds = () => import("../views/admin/ad/AdminAds")
const CreateAd = () => import("../views/admin/ad/CreateAd")
const ModifyAd = () => import("../views/admin/ad/ModifyAd")

const AdminFlights = () => import("../views/admin/flight/AdminFlights")
const CreateFlight = () => import("../views/admin/flight/CreateFlight")
const ModifyFlight = () => import("../views/admin/flight/ModifyFlight")

const Fly = () => import("../views/fly/Fly")
const FlyDetail = () => import("../views/fly/FlyDetail")

const UserFlightsList = () => import("../views/user/flight/UserFlightsList")
const UserCreateFlight = () => import("../views/user/flight/UserCreateFlight")
const UserModifyFlight = () => import("../views/user/flight/UserModifyFlight")

const AdminProspectWebsites = () => import("../views/admin/prospect/website/AdminProspectWebsites")
const AdminAI = () => import("../views/admin/ai/AdminAI")
const AdminLeads = () => import("../views/admin/lead/AdminLeads")
const ModifyLead = () => import("../views/admin/lead/ModifyLead")
const LeadOutreachDashboard = () => import("../views/admin/lead/LeadOutreachDashboard")

const AdminPrivatePersons = () => import("../views/admin/privateperson/AdminPrivatePersons")
const AdminCreatePrivatePerson = () => import("../views/admin/privateperson/AdminCreatePrivatePerson")
const AdminModifyPrivatePerson = () => import("../views/admin/privateperson/AdminModifyPrivatePerson")

const AdminVideos = () => import("../views/admin/video/AdminVideos")

const AdminNewsletterSubscribersList = () => import("../views/admin/newslettersubscriber/AdminNewsletterSubscribersList")

const ModifyPassword = () => import("../views/admin/profile/ModifyPassword")

const ModifyQueries = () => import("../views/admin/ai/ModifyQueries")

const CompanyRegistrationCategory = () => import("../views/company/registration/CompanyRegistrationCategory")
const CompanyRegistrationCompany = () => import("../views/company/registration/CompanyRegistrationCompany")
const CompanyRegistrationCompanyHQ = () => import("../views/company/registration/CompanyRegistrationCompanyHQ")
const CompanyRegistrationCompanyGeocode = () => import("../views/company/registration/CompanyRegistrationCompanyGeocode")
const CompanyRegistrationCompanyPictures = () => import("../views/company/registration/CompanyRegistrationCompanyPictures")
const CompanyRegistrationCompanySubCategory = () => import("../views/company/registration/CompanyRegistrationCompanySubCategory")
const CompanyRegistrationCompanyAircraft = () => import("../views/company/registration/CompanyRegistrationCompanyAircraft")
const CompanyRegistrationCompanyAircraftGeocode = () => import("../views/company/registration/CompanyRegistrationCompanyAircraftGeocode")
const CompanyRegistrationConfirmEmail = () => import("../views/company/registration/CompanyRegistrationConfirmEmail")
const CompanyRegistrationAircraftPictures = () => import("../views/company/registration/CompanyRegistrationAircraftPictures")
const CompanyRegistrationValidation = () => import("../views/company/registration/CompanyRegistrationValidation")

const RegistrationPrivatePerson = () => import("../views/privateperson/registration/RegistrationPrivatePerson")

const HomeView = () => import("../views/Home")

const Map  = () => import("../views/map/Map")

const ProfileView = () => import("../views/user/Profile")
const LoginSecurity = () => import("../views/user/LoginSecurity")
const CustomerService = () => import("../views/user/CustomerService")
const ModifyCompanyAddress = () => import("../views/user/company/ModifyCompanyAddress")
const ModifyCompanyQualificationAircrafts = () => import("../views/user/company/ModifyCompanyQualificationAircrafts")
const ModifyCompanyProfile = () => import("../views/user/company/ModifyCompanyProfile")
const CompanyCreateAircraft = () => import("../views/user/company/aircraft/CompanyCreateAircraft")
const CompanyModifyAircraft = () => import("../views/user/company/aircraft/CompanyModifyAircraft")
const UserAdsList = () => import("../views/user/ad/UserAdsList")
const UserModifyAd = () => import("../views/user/ad/UserModifyAd")
const UserCreateAd = () => import("../views/user/ad/UserCreateAd")
const ModifyPrivatePersonProfile = () => import("../views/user/privateperson/ModifyPrivatePersonProfile")
const ModifyPrivatePersonAddress = () => import("../views/user/privateperson/ModifyPrivatePersonAddress")
const ManageSubscription = () => import("../views/user/privateperson/ManageSubscription")

const ResetPassword = () => import("../views/user/ResetPassword")

const AdminDonationsList = () => import("../views/admin/donation/AdminDonationsList")
const AdminContentDetails = () => import("../views/admin/content/AdminContentDetails")

import LearnPage from "@/views/video/LearnPage"
import LearnMyVideos from "@/views/user/learn/LearnMyVideos"
import LearnNewVideo from "@/views/user/learn/LearnNewVideo"
import LearnModifyVideo from "@/views/user/learn/LearnModifyVideo"

import CommunityPage from "@/views/community/CommunityPage"

const PageNotFound = () => import("../views/PageNotFound")


Vue.use(VueRouter)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const isUserGroup = (group_name) => {
  var userGroups = store.getters.getUserGroups
  var userGroupsArray = []
  var is_contained = false
  if (userGroups) {
    try {
      var userGroupsJson = JSON.parse(userGroups)
      for (var i = 0; i < userGroupsJson.length; i++) {
        userGroupsArray.push(
          userGroupsJson[i]['name']
        )
      }
    }
    catch(error) {
      return is_contained
    }
  }

  for (var j = 0; j < group_name.length; j++) {
    if (userGroupsArray.indexOf(group_name[j]) > -1) {
      is_contained = true
    }
  }
  return is_contained
}

const isConnectedAdmin = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (isUserGroup(['ADMIN'])) {
      next()
      return
    }
    else {
      next('/')
    }
  }
  else {
    next('/')
  }
}

const isConnectedCompany = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (isUserGroup(['COMPANY'])) {
      next()
      return
    }
    else {
      next('/')
    }
  }
  else {
    next('/')
  }
}

const isConnectedPrivatePerson = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (isUserGroup(['PRIVATE'])) {
      next()
      return
    }
    else {
      next('/')
    }
  }
  else {
    next('/')
  }
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: buildTitle('The Home for General Aviation'),
      description: 'Verified airfields, flight schools and operators worldwide, plus daily aviation news and a global community of pilots. The home for general aviation.',
    },
  },
  {
    path: '/chat',
    name: 'chat',
    component: ChatPage,
  },
  {
    path: '/insights',
    name: 'insights',
    component: InsightsPage,
    meta: {
      title: buildTitle('AI-Powered Pilot Insights'),
      description: 'Receive AI-powered flight insights, weather analysis, operational recommendations, route considerations, and personalized information to support safer flying decisions.',
    },
  },
  {
    path: '/map',
    name: 'map',
    component: Map,
    meta: {
      title: buildTitle('Explore Airfields and Aviation Destinations'),
      description: 'Explore airfields, aviation landmarks, scenic destinations, pilot-friendly locations, and unique flying opportunities through an interactive aviation map.',
    },
  },
  {
    path: '/about-features',
    name: 'about-features',
    component: AboutFeaturesPage,
    meta: {
      title: buildTitle('How It Works: Fly, Learn, Map & Hub'),
      description: 'A guided tour of what you can do on AIRspirit: find flying experiences, learn to fly, explore the map of airfields and operators, and join the community hub.',
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyPage,
    meta: {
      title: buildTitle('Privacy Policy & Data Protection'),
      description: 'How AIRspirit collects, uses and protects your personal data, including account information, cookies and your privacy rights as a user.',
    },
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsPage,
    meta: {
      title: buildTitle('Terms of Service & User Agreement'),
      description: 'The terms and conditions governing your use of AIRspirit: accounts, listings, reviews, payments and your rights and obligations as a user.',
    },
  },
  {
    path: '/who-we-are',
    name: 'who-we-are',
    component: WhoWeArePage,
    meta: {
      // Not built with buildTitle(): the brand already opens this title, so
      // the page leads with its promise and closes on "About Us" instead of
      // repeating "AIRspirit" twice.
      title: 'Why AIRspirit Exists | About Us',
      description: 'AIRspirit is an independent platform built to make general aviation easier to discover and easier to trust, for pilots and for everyone who wants to start flying.',
    },
  },
  {
    path: '/news',
    name: 'news',
    component: NewslettersPage,
    meta: {
      title: buildTitle('General Aviation News for Pilots & Owners'),
      description: 'Daily general aviation news: aircraft, manufacturers, regulation, airfields and flight training. Written for pilots, owners, clubs and instructors.',
    },
  },
  {
    path: '/news/:slug',
    name: 'news-article',
    component: NewsArticlePage,
  },
  {
    path: '/hub',
    name: 'hub',
    component: HubPage,
    meta: {
      title: buildTitle('Aviation Community: Pilots, Clubs & Businesses'),
      description: 'Buy, sell and connect with pilots, aircraft owners, aero clubs, instructors and aviation businesses worldwide. One place for the GA community.',
    },
  },
  {
    path: '/hub/ads',
    name: 'hub-ads',
    component: AdsList,
    meta: {
      title: buildTitle('Aircraft & Parts Marketplace'),
      description: 'Browse aircraft, parts and aviation gear for sale from pilots, owners and businesses in the AIRspirit community.',
    },
  },
  {
    path: '/ads/:id',
    name: 'ad-page',
    component: AdPage,
  },
  {
    path: '/admin/ads',
    name: 'admin-ads',
    component: AdminAds,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/ads/create',
    name: 'admin-ads-create-ad',
    component: CreateAd,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/ads/:id',
    name: 'admin-ads-modify',
    component: ModifyAd,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/flights',
    name: 'admin-flights',
    component: AdminFlights,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/flights/create',
    name: 'admin-flights-create',
    component: CreateFlight,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/flights/:id',
    name: 'admin-flights-modify',
    component: ModifyFlight,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/corporations',
    name: 'admin-corporations',
    component: AdminCompanies,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/corporations/create',
    name: 'admin-company-create',
    component: CreateCompany,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/corporations/:companyId/aircrafts/create',
    name: 'admin-aircraft-create',
    component: CreateAircraft,
    beforeEnter: isConnectedAdmin
  },
  
  {
    path: '/admin/corporations/:id',
    name: 'admin-company-modify',
    component: ModifyCompany,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/corporations/:companyId/aircrafts/:id',
    name: 'admin-aircraft-modify',
    component: ModifyAircraft,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/donations',
    name: 'admin-donations',
    component: AdminDonationsList,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/contents/:id',
    name: 'admin-content-detail',
    component: AdminContentDetails,
    beforeEnter: isConnectedAdmin
  },
  {
    // Keep old route for backward compatibility
    path: '/admin/aircraft-accidents/:id',
    redirect: to => `/admin/contents/${to.params.id}`
  },
  {
    path: '/admin/pr',
    name: 'admin-pr',
    component: AdminPR,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/pr/create',
    name: 'admin-pr-create',
    component: CreateNewsletter,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/pr/:id',
    name: 'admin-pr-modify',
    component: ModifyNewsletter,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/events',
    name: 'admin-events',
    component: AdminEvents,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/private-persons',
    name: 'admin-private-persons',
    component: AdminPrivatePersons,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/private-persons/create',
    name: 'admin-private-person-create',
    component: AdminCreatePrivatePerson,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/private-persons/:id',
    name: 'admin-private-person-modify',
    component: AdminModifyPrivatePerson,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/map',
    name: 'admin-map',
    component: AdminCompanies,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/ai_agents',
    name: 'admin-ai',
    component: AdminAI,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/prospect/websites',
    name: 'admin-prospect-websites',
    component: AdminProspectWebsites,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/leads',
    name: 'admin-leads',
    component: AdminLeads,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/leads/dashboard',
    name: 'admin-leads-dashboard',
    component: LeadOutreachDashboard,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/leads/:id',
    name: 'admin-leads-modify',
    component: ModifyLead,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/newsletter-subscribers',
    name: 'admin-newsletter-subscribers',
    component: AdminNewsletterSubscribersList,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/queries',
    name: 'admin-queries-modify',
    component: ModifyQueries,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/admin/password/modify',
    name: 'admin-password-modify',
    component: ModifyPassword,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/admin/learn',
    name: 'admin-learn',
    component: AdminVideos,
    beforeEnter: isConnectedAdmin
  },
  {
    path: '/fly',
    name: 'fly',
    component: Fly,
    meta: {
      title: buildTitle('Discover Extraordinary Flying Experiences'),
      description: 'Browse scenic flights, helicopter tours, seaplane adventures, flying lessons, island hopping experiences, military jet flights, and more around the world.',
    },
  },
  {
    path: '/fly/:id',
    name: 'fly-detail',
    component: FlyDetail,
  },
  {
    path: '/company/registration/category',
    name: 'company-registration-category',
    component: CompanyRegistrationCategory,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/company/registration/information',
    name: 'company-registration-company',
    component: CompanyRegistrationCompany,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/company/registration/confirm-email',
    name: 'company-registration-confirm-email',
    component: CompanyRegistrationConfirmEmail,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/company/registration/hq',
    name: 'company-registration-company-hq',
    component: CompanyRegistrationCompanyHQ,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/company/registration/geocode',
    name: 'company-registration-company-geocode',
    component: CompanyRegistrationCompanyGeocode,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/company/registration/pictures',
    name: 'company-registration-company-pictures',
    component: CompanyRegistrationCompanyPictures,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/company/registration/qualifications',
    name: 'company-registration-company-qualifications',
    component: CompanyRegistrationCompanySubCategory,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/company/registration/aircraft',
    name: 'company-registration-company-aircraft',
    component: CompanyRegistrationCompanyAircraft,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/company/registration/aircraft/:aircraftPk/geocode',
    name: 'company-registration-aircraft-geocode',
    component: CompanyRegistrationCompanyAircraftGeocode,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/company/registration/aircraft/:aircraftPk/pictures',
    name: 'company-registration-aircraft-pictures',
    component: CompanyRegistrationAircraftPictures,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/company/registration/validation',
    name: 'company-registration-validation',
    component: CompanyRegistrationValidation,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/account',
    name: 'profile',
    component: ProfileView,
    beforeEnter: ifAuthenticated 
  },
  {
    path: '/account/login-security',
    name: 'profile-login-security',
    component: LoginSecurity,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/account/customer-service',
    name: 'profile-customer-service',
    component: CustomerService,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/private-person/account/information',
    name: 'private-person-profile-modify-information',
    component: ModifyPrivatePersonProfile,
    beforeEnter: isConnectedPrivatePerson
  },
  {
    path: '/private-person/account/address',
    name: 'private-person-profile-modify-address',
    component: ModifyPrivatePersonAddress,
    beforeEnter: isConnectedPrivatePerson
  },
  {
    path: '/private-person/account/subscription',
    name: 'private-person-profile-subscription',
    component: ManageSubscription,
    beforeEnter: isConnectedPrivatePerson
  },
  {
    path: '/company/account/information',
    name: 'company-profile-modify-information',
    component: ModifyCompanyProfile,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/company/account/address',
    name: 'company-profile-modify-address',
    component: ModifyCompanyAddress,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/company/account/qualifications-fleet',
    name: 'company-profile-modify-qualifications-fleet',
    component: ModifyCompanyQualificationAircrafts,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/company/account/qualifications-fleet/aircrafts/create',
    name: 'company-profile-create-aircraft',
    component: CompanyCreateAircraft,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/company/account/qualifications-fleet/aircrafts/:id/modify',
    name: 'company-profile-modify-aircraft',
    component: CompanyModifyAircraft,
    beforeEnter: isConnectedCompany
  },
  {
    path: '/password/reset/confirmation',
    name: 'reset-password-confirmation',
    component: ResetPassword,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/private-person/registration',
    name: 'private-person-registration',
    component: RegistrationPrivatePerson,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/user/account/ads',
    name: 'user-profile-ads',
    component: UserAdsList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/user/account/ads/:id/modify',
    name: 'user-profile-modify-ad',
    component: UserModifyAd,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/user/account/ads/create',
    name: 'user-profile-create-ad',
    component: UserCreateAd,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/user/account/flights',
    name: 'user-profile-flights',
    component: UserFlightsList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/user/account/flights/create',
    name: 'user-profile-create-flight',
    component: UserCreateFlight,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/user/account/flights/:id/modify',
    name: 'user-profile-modify-flight',
    component: UserModifyFlight,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/user/account/posts/create',
    name: 'user-profile-create-newsletter',
    component: UserCreateNewsletter,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/user/account/posts',
    name: 'user-profile-newsletters',
    component: UserNewslettersList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/user/account/posts/:id/modify',
    name: 'user-profile-modify-newsletter',
    component: UserModifyNewsletter,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/learn',
    name: 'learn',
    component: LearnPage,
    meta: {
      title: buildTitle('Learn to Fly: Flight Schools & Pilot Training'),
      description: 'Compare flight schools worldwide, understand licences, timelines and real costs, and choose your training with verified reviews from pilots who trained there.',
    },
  },
  {
    path: '/user/account/content',
    name: 'learn-videos',
    component: LearnMyVideos,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/user/account/content/new',
    name: 'learn-new-video',
    component: LearnNewVideo,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/user/account/content/edit/:id',
    name: 'learn-edit-video',
    component: LearnModifyVideo,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/community',
    name: 'CommunityPage',
    component: CommunityPage,
    beforeEnter: ifAuthenticated
  },
  {
    path: "*",
    name: 'not-found',
    component: PageNotFound,
    meta: {
      title: buildTitle('Page Not Found'),
      description: 'The page you are looking for does not exist or has moved. Explore aviation news, flight schools and the AIRspirit community instead.',
      noindex: true,
    },
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
})

const DEFAULT_TITLE = buildTitle('The World is Yours to Fly')
const DEFAULT_DESCRIPTION = 'Verified airfields, flight schools and operators worldwide, plus daily aviation news and a global community of pilots. The home for general aviation.'
const CANONICAL_ORIGIN = 'https://airspirit.com'

router.afterEach((to) => {
  document.title = (to.meta && to.meta.title) ? to.meta.title : DEFAULT_TITLE
  const metaDesc = document.querySelector('meta[name="description"]')
  if (metaDesc) {
    metaDesc.setAttribute('content', (to.meta && to.meta.description) ? to.meta.description : DEFAULT_DESCRIPTION)
  }

  // Absolute canonical URL for the current route, one per resource, no
  // query string or trailing slash.
  let canonicalLink = document.querySelector('link[rel="canonical"]')
  if (!canonicalLink) {
    canonicalLink = document.createElement('link')
    canonicalLink.setAttribute('rel', 'canonical')
    document.head.appendChild(canonicalLink)
  }
  const canonicalPath = to.path === '/' ? '' : to.path.replace(/\/+$/, '')
  const canonicalUrl = `${CANONICAL_ORIGIN}${canonicalPath}`
  canonicalLink.setAttribute('href', canonicalUrl)

  // og:url must always match the canonical URL (same resource, one URL).
  let ogUrlMeta = document.querySelector('meta[property="og:url"]')
  if (!ogUrlMeta) {
    ogUrlMeta = document.createElement('meta')
    ogUrlMeta.setAttribute('property', 'og:url')
    document.head.appendChild(ogUrlMeta)
  }
  ogUrlMeta.setAttribute('content', canonicalUrl)

  // Keep pages that shouldn't be indexed (e.g. the 404 page) out of search
  // results, without blocking crawlers from following their links.
  let robotsMeta = document.querySelector('meta[name="robots"]')
  if (!robotsMeta) {
    robotsMeta = document.createElement('meta')
    robotsMeta.setAttribute('name', 'robots')
    document.head.appendChild(robotsMeta)
  }
  robotsMeta.setAttribute('content', (to.meta && to.meta.noindex) ? 'noindex, follow' : 'index, follow')

  // Signal to the prerenderer (puppeteer) that the meta tags for this route
  // have been injected and the HTML snapshot can now be captured.
  Vue.nextTick(() => {
    document.dispatchEvent(new Event('render-event'))
  })
})

export default router
